import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { productsApi, type ProductListItem } from '../crmApi'
import { apiErrorMessage } from '../api'

export function Products() {
  const navigate = useNavigate()
  const [rows, setRows] = useState<ProductListItem[]>([])
  const [availableOnly, setAvailableOnly] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    productsApi.list(availableOnly)
      .then((r) => { setRows(r); setError(null) })
      .catch((e) => setError(describe(e)))
      .finally(() => setLoading(false))
  }, [availableOnly])

  return (
    <div>
      <div className="page-head">
        <h1>Produkter</h1>
        <button className="primary" onClick={() => navigate('/products/new')}>Ny produkt</button>
      </div>
      {error && <p className="error">{error}</p>}

      <div className="card filters">
        <label className="inline">
          <input type="checkbox" checked={availableOnly} onChange={(e) => setAvailableOnly(e.target.checked)} />
          {' '}Endast tillgängliga idag
        </label>
      </div>

      {loading ? <p className="muted">Laddar…</p> : (
        <table className="grid">
          <thead><tr><th>Namn</th><th>Tillgänglig fr.o.m.</th><th>T.o.m.</th><th>Aktuellt pris</th><th>Status</th></tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="clickable" onClick={() => navigate(`/products/${p.id}`)}>
                <td>{p.name}</td>
                <td>{p.availableFrom}</td>
                <td>{p.availableUntil ?? '—'}</td>
                <td>{p.currentPrice != null ? `${p.currentPrice.toFixed(2)} kr` : '—'}</td>
                <td>{p.isAvailableToday
                  ? <span className="badge">Tillgänglig</span>
                  : <span className="badge muted-badge">Ej tillgänglig</span>}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="muted">Inga produkter.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  )
}

const describe = apiErrorMessage
